import { History } from "history";

import {
  GET_NO_PURCHASES_PARENTS_REPORT,
  GET_NO_PURCHASES_PARENTS_REPORT_ERROR,
  GET_NO_PURCHASES_PARENTS_REPORT_SUCCESS,
  GET_NO_PURCHASES_STUDENTS_REPORT,
  GET_NO_PURCHASES_STUDENTS_REPORT_ERROR,
  GET_NO_PURCHASES_STUDENTS_REPORT_SUCCESS,
  GET_NO_SUBSCRIPTION_PARENTS_REPORT,
  GET_NO_SUBSCRIPTION_PARENTS_REPORT_ERROR,
  GET_NO_SUBSCRIPTION_PARENTS_REPORT_SUCCESS,
  GET_NO_SUBSCRIPTION_STUDENTS_REPORT,
  GET_NO_SUBSCRIPTION_STUDENTS_REPORT_ERROR,
  GET_NO_SUBSCRIPTION_STUDENTS_REPORT_SUCCESS,
  GetNoPurchasesParentsReportAction,
  GetNoPurchasesParentsReportErrorAction,
  GetNoPurchasesParentsReportSuccessAction,
  GetNoPurchasesStudentsReportAction,
  GetNoPurchasesStudentsReportErrorAction,
  GetNoPurchasesStudentsReportSuccessAction,
  GetNoSubscriptionParentsReportAction,
  GetNoSubscriptionParentsReportErrorAction,
  GetNoSubscriptionParentsReportSuccessAction,
  GetNoSubscriptionStudentsReportAction,
  GetNoSubscriptionStudentsReportErrorAction,
  GetNoSubscriptionStudentsReportSuccessAction,
  RESET_NO_PURCHASES_PARENTS_REPORT,
  RESET_NO_PURCHASES_STUDENTS_REPORT,
  RESET_NO_SUBSCRIPTION_PARENTS_REPORT,
  RESET_NO_SUBSCRIPTION_STUDENTS_REPORT,
  ResetNoPurchasesParentsReportAction,
  ResetNoPurchasesStudentsReportAction,
  ResetNoSubscriptionStudentsReportAction,
} from "./actionTypes";
import {
  NoPurchasesParentsReportDto,
  NoPurchasesStudentsReportDto,
} from "../../interfaces/reports";

//#region No Purchases Student Report

export const getNoPurchasesStudentsReport = (
  history: History
): GetNoPurchasesStudentsReportAction => {
  return {
    type: GET_NO_PURCHASES_STUDENTS_REPORT,
    payload: { history },
  };
};

export const getNoPurchasesStudentsReportSuccess = (
  response: NoPurchasesStudentsReportDto[]
): GetNoPurchasesStudentsReportSuccessAction => {
  return {
    type: GET_NO_PURCHASES_STUDENTS_REPORT_SUCCESS,
    payload: response,
  };
};

export const getNoPurchasesStudentsReportError = (
  error: any
): GetNoPurchasesStudentsReportErrorAction => {
  return {
    type: GET_NO_PURCHASES_STUDENTS_REPORT_ERROR,
    payload: error,
  };
};

export const resetNoPurchasesStudentsReport =
  (): ResetNoPurchasesStudentsReportAction => {
    return {
      type: RESET_NO_PURCHASES_STUDENTS_REPORT,
      payload: {},
    };
  };

//#endregion

//#region No Purchases Parents Report

export const getNoPurchasesParentsReport = (
  history: History
): GetNoPurchasesParentsReportAction => {
  return {
    type: GET_NO_PURCHASES_PARENTS_REPORT,
    payload: { history },
  };
};

export const getNoPurchasesParentsReportSuccess = (
  response: NoPurchasesParentsReportDto[]
): GetNoPurchasesParentsReportSuccessAction => {
  return {
    type: GET_NO_PURCHASES_PARENTS_REPORT_SUCCESS,
    payload: response,
  };
};

export const getNoPurchasesParentsReportError = (
  error: any
): GetNoPurchasesParentsReportErrorAction => {
  return {
    type: GET_NO_PURCHASES_PARENTS_REPORT_ERROR,
    payload: error,
  };
};

export const resetNoPurchasesParentsReport =
  (): ResetNoPurchasesParentsReportAction => {
    return {
      type: RESET_NO_PURCHASES_PARENTS_REPORT,
      payload: {},
    };
  };

//#endregion

//#region No Subscription Student Report

export const getNoSubscriptionStudentsReport = (
  history: History
): GetNoSubscriptionStudentsReportAction => {
  return {
    type: GET_NO_SUBSCRIPTION_STUDENTS_REPORT,
    payload: { history },
  };
};

export const getNoSubscriptionStudentsReportSuccess = (
  response: NoPurchasesStudentsReportDto[]
): GetNoSubscriptionStudentsReportSuccessAction => {
  return {
    type: GET_NO_SUBSCRIPTION_STUDENTS_REPORT_SUCCESS,
    payload: response,
  };
};

export const getNoSubscriptionStudentsReportError = (
  error: any
): GetNoSubscriptionStudentsReportErrorAction => {
  return {
    type: GET_NO_SUBSCRIPTION_STUDENTS_REPORT_ERROR,
    payload: error,
  };
};

export const resetNoSubscriptionStudentsReport =
  (): ResetNoSubscriptionStudentsReportAction => {
    return {
      type: RESET_NO_SUBSCRIPTION_STUDENTS_REPORT,
      payload: {},
    };
  };

//#endregion

//#region No Subscription Parents Report

export const getNoSubscriptionParentsReport = (
  history: History
): GetNoSubscriptionParentsReportAction => {
  return {
    type: GET_NO_SUBSCRIPTION_PARENTS_REPORT,
    payload: { history },
  };
};

export const getNoSubscriptionParentsReportSuccess = (
  response: NoPurchasesParentsReportDto[]
): GetNoSubscriptionParentsReportSuccessAction => {
  return {
    type: GET_NO_SUBSCRIPTION_PARENTS_REPORT_SUCCESS,
    payload: response,
  };
};

export const getNoSubscriptionParentsReportError = (
  error: any
): GetNoSubscriptionParentsReportErrorAction => {
  return {
    type: GET_NO_SUBSCRIPTION_PARENTS_REPORT_ERROR,
    payload: error,
  };
};

export const resetNoSubscriptionParentsReport =
  (): ResetNoPurchasesParentsReportAction => {
    return {
      type: RESET_NO_SUBSCRIPTION_PARENTS_REPORT,
      payload: {},
    };
  };

//#endregion
